/* istanbul ignore file */

import type { SVGProps } from 'react';
import { useTheme } from 'styled-components';

import type theme from '@shared/theme';

type Props = SVGProps<SVGSVGElement> & {
    strokeColor?: keyof typeof theme.colors;
};

export default function PlusIcon({ strokeColor, ...props }: Props) {
    const theme = useTheme();

    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            role="img"
        >
            <path
                stroke={strokeColor ? theme.colors[strokeColor] : '#282B43'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10 17.52c4.418 0 8-3.402 8-7.6 0-4.197-3.582-7.6-8-7.6s-8 3.403-8 7.6c0 4.198 3.582 7.6 8 7.6ZM10 6.883v6.08M6.8 9.922h6.4"
            />
        </svg>
    );
}
